export const PERIODICITE_VERSEMENT = {
  MENSUEL: 'Mensuel',
  BIMENSUEL: 'Bimensuel',
  HEBDOMADAIRE: 'Hebdomadaire',
};

export const PERIODICITE_ARRETE = {
  MENSUEL: 'Mensuel',
  BIMENSUEL: 'Bimensuel',
  HEBDOMADAIRE: 'Hebdomadaire',
};

export const JOURS_VERSEMENT = {
  LUNDI: 'Lundi',
  MARDI: 'Mardi',
  MERCREDI: 'Mercredi',
  JEUDI: 'Jeudi',
  VENDREDI: 'Vendredi',
};
